import React from "react";
import styles from "./Contact.module.css";
import { Container } from "../../common/Container";
import { ContactForm } from "./ContactForm";
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver";
import clsx from "clsx";
import { FiMail, FiMapPin } from "react-icons/fi";

export const Contact: React.FC = () => {
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section id="contact" className={styles.contact} ref={ref}>
      <Container>
        <div
          className={clsx(styles.contactContent, isVisible && styles.visible)}
        >
          <div className={styles.header}>
            <h2 className={styles.heading}>Get In Touch</h2>
            <p className={styles.description}>
              Whether you want to talk about one of my apps, explore acquisition
              or collaboration, or have a project to discuss — I'd love to hear
              from you.
            </p>
          </div>

          <div className={styles.contentWrapper}>
            {/* Contact Information */}
            <div className={styles.info}>
              <h3 className={styles.infoHeading}>Contact Information</h3>

              <div className={styles.infoItems}>
                <div className={styles.infoItem}>
                  <div className={styles.iconWrapper}>
                    <FiMail />
                  </div>
                  <div className={styles.infoText}>
                    <h4>Email</h4>
                    <p>dixonappdevelopment@gmail.com</p>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <div className={styles.iconWrapper}>
                    <FiMapPin />
                  </div>
                  <div className={styles.infoText}>
                    <h4>Location</h4>
                    <p>Remote</p>
                  </div>
                </div>
              </div>

              <div className={styles.responseTime}>
                <p className={styles.responseTitle}>Response Time</p>
                <p className={styles.responseText}>
                  I typically respond within 24–48 hours.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className={styles.formWrapper}>
              <ContactForm />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
